import { binaryToHex, EcdsaSecp256r1, randomBytes, toUserId, } from '@streamr/utils';
import { AES_KEY_SIZE } from './KeyStore';
export function generateKeysAndUserId() {
    const signingUtil = new EcdsaSecp256r1();
    const keyPair = signingUtil.generateKeyPair();
    const privateKeyRaw = keyPair.privateKey;
    const privateKey = binaryToHex(privateKeyRaw);
    const userId = toUserId(keyPair.publicKey);
    const aesKeyRaw = randomBytes(AES_KEY_SIZE);
    const aesKey = binaryToHex(aesKeyRaw);
    return {
        privateKey,
        userId,
        aesKey,
    };
}
